import {
    Box,
    Checkbox,
    Divider,
    FormControlLabel,
    Grid,
    Typography,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setUserData } from '../../store/features/user/userSlice';
import CustomizedButtons from '../../components/custom-button/custom-button.component';
import CustomInput from '../../components/custom-input/custom-input.component';
import ContainerRounded from '../../styled-components/container-rounded';
import * as yup from 'yup';
import { useState, useEffect } from 'react';
import { createCustomer } from '../../services/customer.service';

const CustomSubtitle = ({ text }) => {
    return (
        <Typography variant="h4" gutterBottom>
            {text}
        </Typography>
    );
};

let Schema = yup.object().shape({
    nickName: yup.string().required(),
    identificationNumber: yup.string().required(),
    birthdate: yup.string().required(),
    phoneNumber: yup.string().required(),
    termAndConditionsAccepted: yup.boolean().isTrue().required(),
    customerValidDataAccepted: yup.boolean().isTrue().required(),
});

const AddCustomer = () => {
    const dispatch = useDispatch();

    const { authData } = useSelector((state) => state.auth);
    const { userData } = useSelector((state) => state.user);
    const [isValidForm, setIsValidForm] = useState(false);

    useEffect(() => {
        Schema.isValid(userData).then(function (valid) {
            setIsValidForm(valid);
        });
    }, [userData]);

    useEffect(() => {
        console.log('authData', authData);
    }, [authData]);

    const handleChange = (e) => {
        if (e.target.type === 'checkbox') {
            dispatch(
                setUserData({ ...userData, [e.target.name]: e.target.checked })
            );
        } else {
            dispatch(
                setUserData({ ...userData, [e.target.name]: e.target.value })
            );
        }
    };

    const handleCreateUser = () => {
        const payload = {
            access_token: authData.access_token,
            customerData: JSON.stringify(userData),
        };
        dispatch(createCustomer(payload));
    };

    return (
        <ContainerRounded
            style={{ flexDirection: 'column', justifyContent: 'space-between' }}
        >
            <Box
                xs={12}
                sx={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'end',
                    minHeight: '6rem',
                }}
            >
                <CustomSubtitle text="Crear tu cuenta" />
            </Box>
            <Grid
                container
                sx={{
                    margin: '45px 0 25px',
                    paddingX: '20px',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <Grid item xs={12}>
                    <CustomInput
                        onChange={handleChange}
                        name="nickName"
                        label={'Nombre de Usuario'}
                    />
                </Grid>
                <Grid container item>
                    <Grid item xs={5}>
                        <CustomInput
                            onChange={handleChange}
                            name="identificationType"
                            defaultValue="DNI"
                            label={'Tipo de documento'}
                            readOnly
                        />
                    </Grid>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={6}>
                        <CustomInput
                            onChange={handleChange}
                            name="identificationNumber"
                            label={'Número'}
                            type="number"
                        />
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <CustomInput
                        onChange={handleChange}
                        name="birthdate"
                        label={'Fecha de nacimiento'}
                        type="date"
                    />
                </Grid>
                <Grid item xs={12}>
                    <CustomInput
                        onChange={handleChange}
                        name="phoneNumber"
                        label={'Número de celular'}
                        type="tel"
                    />
                </Grid>
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        sx={{ color: '#FFF' }}
                        control={
                            <Checkbox
                                sx={{ color: '#FFF' }}
                                color="beige"
                                name="termAndConditionsAccepted"
                                onChange={handleChange}
                            />
                        }
                        label="Acepto los términos y condiciones"
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        sx={{ color: '#FFF' }}
                        control={
                            <Checkbox
                                sx={{ color: '#FFF' }}
                                color="beige"
                                name="customerValidDataAccepted"
                                onChange={handleChange}
                            />
                        }
                        label="Declaro bajo juramento que los datos ingresados son correctos."
                    />
                </Grid>
            </Grid>
            <Grid
                item
                xs={12}
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    backgroundColor: '#FFF',
                    padding: '1rem 1.25rem 2rem',
                    borderRadius: '30px 30px 0 0',
                }}
            >
                <CustomizedButtons
                    disabled={!isValidForm}
                    label={'Siguiente'}
                    handleClick={handleCreateUser}
                />
            </Grid>
        </ContainerRounded>
    );
};

export default AddCustomer;
